module.exports = "<div class=\"content_wrapper\">\n\t\t\t\t\n\t<app-advanced-form-search (searchHandler)=\"search($event)\" fieldsJsonFile=\"booking-searchfields\" [ebModuleNum]=\"1\" [ebCompNum]=\"1\"></app-advanced-form-search>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/saved-forms/pricing-mask/pricing-mask-filler.component.html
// module id = ./src/app/component/saved-forms/pricing-mask/pricing-mask-filler.component.html
// module chunks = main